import React from "react";
import { Brain, ChartLine, Atom, GitBranch } from "@phosphor-icons/react";

export const TechCore = () => {
  return (
    <section id="tech" data-testid="tech-section" className="relative py-24 sm:py-32">
      <div className="absolute inset-0 grid-bg opacity-25 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-7">
            <div className="mono text-xs uppercase tracking-[0.22em] text-brand-cyan mb-3">
              / 02 — Технологическое ядро
            </div>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
              «Вычислительный дарвинизм»
              <br />
              <span className="text-brand-cyan">для Kubernetes.</span>
            </h2>
            <p className="mt-6 text-muted text-base leading-relaxed max-w-2xl">
              Мы заменяем стандартный планировщик интеллектуальным ядром на базе{" "}
              <span className="text-ink-text mono">RL + GNN</span>. Каждая задача и каждый GPU
              получают вес — выживает сильнейшее назначение.
            </p>
          </div>
        </div>

        {/* Bento */}
        <div className="grid lg:grid-cols-12 gap-6">
          {/* Formula card — span 7 */}
          <div className="lg:col-span-7 glass-strong rounded-2xl p-8 sm:p-10 relative overflow-hidden">
            <div className="mono text-[10px] uppercase tracking-[0.22em] text-brand-cyan mb-6">
              Scoring Function
            </div>
            <div className="relative">
              <div className="font-heading font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-none">
                Score ={" "}
                <span className="text-brand-cyan text-glow-cyan">КЭИ</span>{" "}
                ×{" "}
                <span className="text-ink-text">(1 −</span>{" "}
                <span className="text-brand text-glow-blue">ЗКЗ</span>
                <span className="text-ink-text">)</span>
              </div>
              <div className="absolute -bottom-3 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-cyan/60 to-transparent" />
            </div>

            <div className="mt-10 grid sm:grid-cols-2 gap-6">
              <div className="rounded-xl bg-ink-surface/60 border border-ink-text/5 p-5">
                <div className="flex items-center gap-2 mono text-xs uppercase tracking-widest text-brand-cyan mb-3">
                  <Atom size={14} weight="bold" /> КЭИ
                </div>
                <div className="font-heading font-semibold text-lg mb-2">
                  Коэффициент эффективности
                </div>
                <div className="text-sm text-muted leading-relaxed">
                  Замеряет реальную физику железа:{" "}
                  <span className="mono text-ink-text">T_test / T_actual</span>. Учитывает PCIe,
                  тепловой троттлинг, NVLink-топологию.
                </div>
              </div>

              <div className="rounded-xl bg-ink-surface/60 border border-ink-text/5 p-5">
                <div className="flex items-center gap-2 mono text-xs uppercase tracking-widest text-brand mb-3">
                  <GitBranch size={14} weight="bold" /> ЗКЗ
                </div>
                <div className="font-heading font-semibold text-lg mb-2">
                  Зональная конкуренция за ресурсы
                </div>
                <div className="text-sm text-muted leading-relaxed">
                  Управляет загрузкой зон кластера, предотвращает фрагментацию инфраструктуры.
                </div>
              </div>
            </div>

            <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-brand/15 blur-[80px] pointer-events-none" />
          </div>

          {/* Right column — RL + GNN cards */}
          <div className="lg:col-span-5 flex flex-col gap-6">
            <div className="glass rounded-2xl p-7 relative overflow-hidden flex-1">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-brand/10 border border-brand/30 flex items-center justify-center">
                  <Brain size={20} weight="duotone" className="text-brand-cyan" />
                </div>
                <div>
                  <div className="font-heading font-semibold">RL-агент</div>
                  <div className="mono text-[10px] uppercase tracking-widest text-muted">Reinforcement Learning</div>
                </div>
              </div>
              <p className="text-sm text-muted leading-relaxed">
                Политика обучается на исторической телеметрии DCGM и непрерывно
                адаптируется к нагрузке. Reward = пропускная способность × энергоэффективность.
              </p>
            </div>

            <div className="glass rounded-2xl p-7 relative overflow-hidden flex-1">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-brand-cyan/10 border border-brand-cyan/30 flex items-center justify-center">
                  <ChartLine size={20} weight="duotone" className="text-brand-cyan" />
                </div>
                <div>
                  <div className="font-heading font-semibold">GNN-эмбеддинг</div>
                  <div className="mono text-[10px] uppercase tracking-widest text-muted">Graph Neural Network</div>
                </div>
              </div>
              <p className="text-sm text-muted leading-relaxed">
                Кодирует кластер как взвешенный двудольный граф «задача ↔ ресурс» с учётом
                NUMA, NVLink* и сетевой топологии.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechCore;
